import React from "react";
import "./Button.scss";

const SubmitButton = ({
  text,
  className = "",
  varient = "",
  disabled = false,
  loading = false,
  onClick,
  ...rest
}) => {
  return (
    <button
      className={`button button-${varient} ${className} ${
        disabled || loading ? `button-${varient}-disabled` : ""
      }`}
      onClick={onClick}
      disabled={disabled || loading} 
      {...rest}
    >
      <span>
        {text}
        {varient !== "search" && loading && (
          <span className="loader mx-2"></span>
        )}
      </span>
    </button>
  );
};

export default SubmitButton;